import React from "react";

// Context
import { useAuth } from "../../contexts/AuthContext";
import { useFirstTimeUser } from "../../hooks/useFirstTimeUser";

// Components
import AccountInformation from "./containers/AccountInformation";
import ChangePassword from "./containers/ChangePassword";
import DeleteAccount from "./containers/DeleteAccount";

const ProfilePage = () => {
    const { user } = useAuth();
    const { resetFirstTimeState } = useFirstTimeUser();
    
    if (!user) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg text-black">
                    Please log in or sign up to view your profile
                </div>
            </div>
        );
    }

    const handleResetVideo = () => {
        resetFirstTimeState();
        alert("Video popup has been reset. Refresh the page to see it again.");
    };

    return (
        <div className="max-w-2xl mx-auto mt-16 p-6">
            <AccountInformation />
            <ChangePassword />
            <DeleteAccount />
            
            {/* Development/Testing Section */}
            {/* <div className="mt-8 p-4 bg-gray-50 rounded-lg border">
                <h3 className="text-lg font-semibold mb-3 text-gray-800">Development Tools</h3>
                <button
                    onClick={handleResetVideo}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                >
                    Reset Welcome Video (Show Again)
                </button>
                <p className="text-sm text-gray-600 mt-2">
                    This button resets the welcome video popup so you can test it again.
                </p>
            </div> */}
        </div>
    );
};

export default ProfilePage;
